const allowedFileTypes = [
  "image/jpeg",
  "image/png",
  "application/pdf",
  "video/mp4",
];
const maxFileSizeMB = 100;

export const handleFileChange = (event) => {
  const selectedFile = event.target.files[0];

  if (selectedFile) {
    const fileSizeInBytes = selectedFile.size;
    const fileSizeInMB = fileSizeInBytes / (1024 * 1024); // Convert bytes to megabytes

    if (
      fileSizeInMB > maxFileSizeMB ||
      !allowedFileTypes.includes(selectedFile.type)
    ) {
      return false;
    } else {
      return true;
    }
  }
};
